import axios from 'axios';
export async function getRelationByKey(relationOid, token) {
    const res = await axios.get(`/api/odata/Relation(${relationOid})?$expand=Contracts,WorkLocations`, getHeaders(token));
    try {
        return res.data;
    }
    catch {
        return res;
    }
}

export async function getNotes(relationOid, token) {
    const res = await axios.get(`/api/odata/Report?$filter=Contract/Relation/Oid eq ${relationOid}&$select=Remark,MaintenanceDate,DoneByName,QuotationSent,MoreWorkNeeded,RemarkDone`, getHeaders(token));
    try {
        return res.data.value;
    }
    catch {
        return res;
    }
}

export async function getExcatOnlineRelations(token) {
    const res = await axios.get('/api/relations/GetExcatOnlineRelations', getHeaders(token));
    try {
        return res.data;
    }
    catch {
        return res;
    }
}

export async function updateExactOnlineRelations(token) {
    const res = await axios.get('/api/relations/UpdateExactOnlineRelations', getHeaders(token));
    try {
        return res.data;
    }
    catch {
        return res;
    }
}

export interface RelationFormData {
    Name: string;
    Company?: string;
    ContactPerson?: string;
    CustomerNumber?: string;
    Gender: number;
    Email?: string;
    InvoiceEmail?: string;
    TelephoneNumber?: string;
    Address?: string;
    AddressNr?: string;
    ZipCode?: string;
    City?: string;
}

export async function deleteRelation(oid: string, token: string): Promise<void> {
    await axios.delete(`/api/relations/${oid}`, getHeaders(token));
}

export async function createRelation(data: RelationFormData, token: string): Promise<{ Oid: string }> {
    const res = await axios.post('/api/relations/Create', data, getHeaders(token));
    return res.data;
}

export async function updateRelation(oid: string, data: RelationFormData, token: string): Promise<void> {
    await axios.put(`/api/relations/${oid}/Update`, data, getHeaders(token));
}

export interface WorkLocationFormData {
    RelationOid: string;
    Name: string;
    Address?: string;
    AddressNr?: string;
    ZipCode?: string;
    City?: string;
    ContactPerson?: string;
    TelephoneNumber?: string;
}

export async function createWorkLocation(data: WorkLocationFormData, token: string): Promise<{ Oid: string }> {
    const res = await axios.post('/api/WorkLocation/Create', data, getHeaders(token));
    return res.data;
}

export async function updateWorkLocation(oid: string, data: WorkLocationFormData, token: string): Promise<void> {
    await axios.put(`/api/WorkLocation/${oid}/Update`, data, getHeaders(token));
}

export async function deleteWorkLocation(oid: string, token: string): Promise<void> {
    await axios.delete(`/api/WorkLocation/${oid}`, getHeaders(token));
}

const getHeaders = (token) => {
    return {
        headers: {
            'Accept': 'application/json',
            'Content-Type': 'application/json',
            'Authorization': `Bearer ${token}`
        }
    };
};

